import React, { useEffect, useState } from 'react';

type UseAsyncObject<T> = {
  data: T | undefined;
  loading: boolean;
  error: Error | undefined;
  setData: React.Dispatch<React.SetStateAction<T | undefined>>;
};

/**
 * @param getter Fucntion to fetch data with
 * @param dependencies Dependencies for a useEffect hook
 * @param filter Optional filter function to run on received data
 * @returns {UseAsyncObject} Async Object
 */
export default function useAsyncData<T>(
  getter: () => Promise<T>,
  dependencies?: any
): UseAsyncObject<T> {
  const [data, setData] = useState<T>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error>();

  useEffect(() => {
    if (loading) return;
    let isMounted = true;
    setLoading(true);
    getter()
      .then((res) => {
        if (isMounted) setData(res);
      })
      .catch((e) => setError(e))
      .finally(() => setLoading(false));
    return () => {
      isMounted = false;
    };
  }, [dependencies]);

  return { data, loading, error, setData };
}
